import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";

function BarLeasingJobType({ countPurpose }) {
  const options = {
    scales: {
      xAxes: [
        {
          display: true, // hides the horizontal scale
          stacked: true, // stacks the bars on the x axis
        },
      ],
      yAxes: [
        {
          display: true,
          ticks: {
            beginAtZero: true, // minimum value will be 0.
          },
          display: true, // hides the vertical scale
          stacked: true, // stacks the bars on the y axis
        },
      ],
    },
    title: {
      display: true,
      text: "Job Type",
      fontSize: 20,
    },
    legend: {
      display: false,
      // position: "top",
    },
  };

  const mockData = {
    labels: ["จำนำ", "เช่าซื้อ"],
    datasets: [
      {
        label: "จำนำ",
        data: [65, 0, 0],
        backgroundColor: [
          "rgb(234, 179, 8)",
          "rgb(34, 197, 94)",
          "rgb(239, 68, 68)",
        ],
      },
      {
        label: "เช่าซื้อ",
        data: [0, 20, 0],
        backgroundColor: [
          "rgb(234, 179, 8)",
          "rgb(34, 197, 94)",
          "rgb(239, 68, 68)",
        ],
      },
    ],
  };

  const data = useMemo(() => {
    delete countPurpose.UNKNOWN;
    const datasets = Object.keys(countPurpose).map((key, index) => {
      let data = new Array(3).fill(0);
      data[index] = countPurpose[key].total;
      return {
        label: countPurpose[key].name,
        data: data,
        backgroundColor: ["rgb(230, 230, 230)", "rgb(230, 230, 230)"],
      };
    });

    return {
      labels: ["จำนำ", "เช่าซื้อ"],
      datasets,
    };
  }, []);

  return (
    <div className="p-4 md:p-10 md:mx-4">
      <Bar data={data} options={options} />
    </div>
  );
}

export default BarLeasingJobType;
